export interface MultiNodeNode<T> {
  elements: T[]
  cloneNode(): T
  parentNode: ParentNode
  style: CSSStyleDeclaration
  classList: DOMTokenList
}

export function makeMultiNodeNode(elements: Element[], initialEvent: MouseEvent): MultiNodeNode<HTMLElement> {
  const originalSource = {
    isMultiNodeNode: true,
    elements: elements as HTMLElement[],
    cloneNode() {
      // returns the nodes grouped into a single div
      const div = document.createElement('div')
      const clonedElements = elements.map(el => el.cloneNode(true))
      div.append(...clonedElements)
      div.classList.add('tile-wrapper')
      div.setAttribute('inert', 'true')
      return div
    },
    parentNode: {
      insertBefore(newNode: Node, _referenceNode: Node) {
        if ('elements' in newNode) {
          insertMultiNodeBefore.call(elements[0].parentNode!, originalSource, elements[0])
        } else {
          _insertBefore.call(elements[0].parentNode!, newNode, elements[0])
        }
      },
    } as ParentNode,
    style: {
      set display(val: string) {
        for (let el of elements) {
          ;(el as HTMLElement).style.display = val
        }
      },
    } as CSSStyleDeclaration,
    classList: {
      add(...tokens: string[]) {
        for (let el of elements) {
          ;(el as HTMLElement).classList.add(...tokens)
        }
      },
      remove(...tokens: string[]) {
        for (let el of elements) {
          ;(el as HTMLElement).classList.remove(...tokens)
        }
      },
    } as DOMTokenList,
  }
  return originalSource
}

const _insertBefore = Node.prototype.insertBefore
export function insertMultiNodeBefore<T extends Node>(this: ParentNode, newNode: T | MultiNodeNode<T>, referenceNode: Node): T {
  if ('elements' in newNode) {
    let retval: T | null = null
    for (let node of newNode.elements) {
      retval = _insertBefore.call<ParentNode, [T, Node], T>(this, node, referenceNode)
    }
    return retval!
  } else {
    return _insertBefore.call<ParentNode, [T, Node], T>(this, newNode, referenceNode)
  }
}
